module.exports = __webpack_public_path__ + "img/marinesciences-h-474x356.e77b899b.jpg";